import { gql } from '@apollo/client';

const FACILITY_QUERY = gql`
  query facility($id: ID!) {
    facility(id: $id) {
      id
      name
      friendlyId
      contact {
        address
        city
        state
        country
        zip
        phone1
        phone2
        nightPhone
        fax
      }
      facilityNote
      clinicianContacts {
        name
        phone
        email
        description
      }
      assignedSalesRepresentative {
        id
        firstName
        lastName
        contact {
          phone1
        }
        email
      }
    }
  }
`;

export default FACILITY_QUERY;
